import { verifyIdNumber } from "../checkIdNumber";

export default [
  {
    ruleName: 'required',
    enabled: field => field?.rawData?.required,
    errorMessage: (field) => "此欄位必填", // eslint-disable-line no-unused-vars
    validator: (value) => (value || '').toString().trim() !== '',
  },
  {
    ruleName: 'regex',
    enabled: field => !!field?.rawData?.regex,
    errorMessage: (field) => field?.rawData?.regex_error_message || "格式錯誤",
    validator: (value, field) => !value || (new RegExp(field.rawData.regex, "gu")).test(value),
  },
  {
    ruleName: 'mobile_phone',
    enabled: field => field?.rawData?.type === 'mobile_phone',
    errorMessage: (field) => "手機格式錯誤", // eslint-disable-line no-unused-vars
    validator: (value) => /09[0-9]{8}/.test(value) && value.length === 10,
  },
  {
    ruleName: 'taiwan_id_number',
    enabled: field => field?.rawData?.type === 'TWIDNumber',
    errorMessage: (field) => "身分證字號錯誤", // eslint-disable-line no-unused-vars
    validator: (value) => verifyIdNumber(value),
  },
]
